const siteModeratorsEmailChecks = [
  {
    severity: "ERROR",
    type: "EVENT",
    fieldName: "proposed",
    errorMessage: "Following e-mail address is not valid: ",
    resolutionMessage: "Please fix the invalid admin email address",
  },
];

export default siteModeratorsEmailChecks;
